import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="text-lg font-bold mb-4 font-heading">
              <Link to="/" className="hover:opacity-80 transition-opacity cursor-pointer">
                51cg黑料揭秘
              </Link>
            </h4>
            <p className="text-sm text-background-50/70 leading-relaxed">
              致力于为用户提供51cg平台最真实、最全面、最及时的爆料信息与深度分析，帮助每一位用户做出明智的决策。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wide text-background-50/60">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wide text-background-50/60">
              热门文章
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/article/51cg-zijin-anquan-tixian-kunnan"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  资金安全存疑：提现困难
                </Link>
              </li>
              <li>
                <Link
                  to="/article/51cg-yuangong-niming-baoliao"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  前员工匿名爆料内幕
                </Link>
              </li>
              <li>
                <Link
                  to="/article/51cg-bikeng-zhinan-xinyonghu"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  新用户避坑指南
                </Link>
              </li>
              <li>
                <Link
                  to="/article/51cg-falv-fengxian-quanjiexi"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  法律风险全解析
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wide text-background-50/60">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  用户协议
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  隐私政策
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  免责声明
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/50">
            &copy; {new Date().getFullYear()} 51cg黑料揭秘. 本站内容仅供参考，不构成任何投资建议。
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" aria-label="RSS">
              <i className="ri-rss-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}